"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicDropdown = void 0;
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _FormControls = require("../../go/components/common/FormControls");
var _semanticUiReact = require("semantic-ui-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
//Control [Add,Remove] Spec
var controlSpec = {
  Add: {
    title: 'remove community lifeline',
    behaviour: 'Addition',
    id: 'addSelect'
  },
  remove: {
    title: 'remove community lifeline',
    behaviour: 'Remove',
    id: 'removeSelect'
  }
};
var DynamicDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicDropdown, _React$Component);
  var _super = _createSuper(DynamicDropdown);
  function DynamicDropdown(_props) {
    var _this;
    _classCallCheck(this, DynamicDropdown);
    _this = _super.call(this, _props);
    // generate options for dropdown based on data that comming or defined in the dependencies, if there is another way use condition
    // return single abstract option
    _this.generateOptions = function (condition) {
      var generatedOptions;
      if (condition === 'default') {
        var _iterator = _createForOfIteratorHelper(_this.props.dependencies),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var dependency = _step.value;
            var obj = _defineProperty({}, Object.keys(dependency)[0], _lodash.default.get(_this.props.context, Object.values(dependency)[0]));
            generatedOptions = _objectSpread(_objectSpread({}, generatedOptions), obj);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return generatedOptions;
    };
    // This function responsible on how to produce your options after you getting them from generate Options function.
    //if there is another way to transofrom options separate them by condition but keep to reuse code if possible
    _this.transformedOptions = function (props) {
      _this.options = [];
      _this.flatOptions = [];
      var rawOptions = _this.generateOptions('default', _this.props);
      var dependencyData = rawOptions.dependencyData;
      var referenceData = rawOptions.referenceDataPath;
      _lodash.default.map(dependencyData, function (entry) {
        delete referenceData.loading;
        if (_this.props.referenceKey) {
          var reqObj = _lodash.default.find(referenceData, ['id', entry[props.referenceKey]]);
          _this.flatOptions.push({
            key: reqObj.id,
            value: reqObj.displayText,
            text: reqObj.displayText,
            type: 'header',
            disabled: true,
            style: {
              color: 'black',
              fontWeight: 'bold',
              paddingleft: '15em'
            }
          });
        } else {
          var _reqObj = _lodash.default.find(referenceData, ['id', entry]);
          if (_reqObj) {
            _this.flatOptions.push({
              key: _reqObj.id,
              value: _reqObj.displayText,
              text: _reqObj.displayText,
              type: 'header'
            });
          }
        }
        if (_this.props.referenceChildKey && _this.props.displayChildren) {
          var children = entry[_this.props.referenceChildKey];
          _lodash.default.map(children, function (child) {
            var foundObject = _lodash.default.find(referenceData, ['id', child]);
            if (foundObject) {
              _this.flatOptions.push({
                key: foundObject.id,
                value: foundObject.displayText,
                text: foundObject.displayText,
                type: 'item',
                disabled: false
              });
            }
            return _lodash.default.find(referenceData, ['id', child]);
          });
        }
        _this.options = _this.flatOptions;
      });
    };
    _this.handleChange = function (e, id) {
      var clonedValues = _lodash.default.clone(_this.state.dataPathsValues);
      clonedValues[id] = e.target.value;
      _this.setState({
        dataPathsValues: clonedValues,
        pointTo: id
      }, _this.handleBlur);
    };
    _this.handleBlur = function () {
      _this.updateData();
    };
    _this.handledropdownControls = function (behaviour) {
      if (behaviour === 'Addition') {
        var getNext = _this.state.activeLists + 1;
        _this.setState({
          activeLists: getNext
        });
      }
      if (behaviour === 'Remove') {
        var _getNext = _this.state.activeLists - 1;
        var clonedValues = _lodash.default.clone(_this.state.dataPathsValues);
        clonedValues[_getNext] = undefined;
        _this.setState({
          activeLists: _getNext,
          pointTo: _getNext,
          dataPathsValues: clonedValues
        }, _this.handleBlur);
      }
    };
    _this.updateData = function () {
      var value = _this.state.dataPathsValues[_this.state.pointTo];
      _this.props.saveEntityData(_this.props.entityDataPath[_this.state.pointTo], _this.props.entityType, value);
    };
    _this.Controls = function (Spec, index) {
      if (_this.props.showControls) {
        if (Spec.behaviour === 'Addition' && _this.state.activeLists + 1 > _this.props.entityDataPath.length) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        }
        if (Spec.behaviour === 'Remove' && _this.state.activeLists === 1) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        }
        if (Spec.behaviour === 'Remove' && index + 1 != _this.state.activeLists) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "margin-bottom--standard"
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
          disabled: Spec.behaviour === 'Addition' && _this.state.dataPathsValues[_this.state.activeLists - 1] === undefined ? true : false,
          basic: true,
          Button: true,
          primary: Spec.behaviour === 'Addition' ? true : false,
          href: "#",
          compact: true,
          title: Spec.behaviour === 'Addition' ? _this.props.addText : Spec.title,
          id: Spec.id,
          onClick: function onClick() {
            _this.handledropdownControls(Spec.behaviour);
          }
        }, Spec.behaviour === 'Addition' ? _this.props.addText : /*#__PURE__*/_react.default.createElement("a", {
          href: "#"
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "close",
          color: "blue"
        }), "Remove")));
      } else {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }
    };
    _this.render = function () {
      var _this$props = _this.props,
        isHidden = _this$props.isHidden,
        entityDataPath = _this$props.entityDataPath,
        guidance = _this$props.guidance,
        formOptions = _this$props.formOptions,
        size = _this$props.size,
        validationErrors = _this$props.validationErrors,
        validationDirtyMap = _this$props.validationDirtyMap;
      var validationErrorsArray = _lodash.default.isEmpty(validationErrors) || _lodash.default.isArray(validationErrors) ? validationErrors : [validationErrors];
      var firstError = _lodash.default.find(validationErrorsArray, function (err) {
        return !err.isValid;
      }) || false;
      var errorMessage = firstError ? firstError.message : false;
      var displayError = firstError && validationDirtyMap.dirty;
      if (isHidden) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }
      var renderSelect = _lodash.default.map(entityDataPath, function (path, index) {
        if (index < _this.state.activeLists) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
            columns: "2",
            verticalAlign: "middle"
          }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
            width: "13"
          }, /*#__PURE__*/_react.default.createElement(_FormControls.Select, {
            value: _this.state.dataPathsValues[index],
            options: _this.getInstance(index),
            size: size,
            name: entityDataPath[index],
            handleChange: function handleChange(e) {
              return _this.handleChange(e, index);
            },
            formOptions: formOptions,
            displayError: displayError,
            errorMessages: errorMessage,
            guidance: guidance[index],
            defaultValue: _this.props.addInitialOption ? _this.props.initialOption : ''
          })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
            width: "3"
          }, _this.Controls(controlSpec.remove, index))));
        } else {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        }
      });
      return /*#__PURE__*/_react.default.createElement("div", null, renderSelect, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
        columns: "1"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        width: "12"
      }, _this.Controls(controlSpec.Add))));
    };
    _this.transformedOptions(_props);
    var isInitial = _lodash.default.without(_props.data, undefined).length === 0;
    _this.state = {
      dataPathsValues: _props.data,
      pointTo: 0,
      activeLists: isInitial === true ? 1 : _lodash.default.without(_props.data, undefined).length
    };
    return _this;
  }
  _createClass(DynamicDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getInstance",
    value:
    //This function provide instance of managed options [ exelusion as example , resrtictions or disable /enable some options based on rules come from config]
    function getInstance(index) {
      var clonedArray = this.options === undefined ? [] : _toConsumableArray(this.options);
      var valuesToBeExecluded = [];
      var pointer = index; // there is another index used inside the loop that is why we named pointer
      var self = this;
      pointer = index;
      if (this.props.applyExeclusion) {
        _lodash.default.forEach(self.props.entityDataPath, function (path, index) {
          if (pointer != index) {
            var val = _lodash.default.find(self.options, ['value', self.state.dataPathsValues[index]]);
            if (val) valuesToBeExecluded.push(val);
          }
        });
        if (valuesToBeExecluded.length) {
          _lodash.default.pullAllWith(clonedArray, valuesToBeExecluded, _lodash.default.isEqual);
        }
      }
      return clonedArray;
    }
  }]);
  return DynamicDropdown;
}(_react.default.Component);
exports.DynamicDropdown = DynamicDropdown;